export default __webpack_public_path__ + "static/media/replaceIcon.db4b3b66.svg";